export enum NotificationAudience {
  Provider = "provider",
  Organization = "organization",
  OrganizationMember = "organization-member",
}

export function getProviderNotificationAudience(
  jobPostsEnabled?: boolean,
): NotificationAudience {
  // Keep prompts free of marketplace messaging until account access is known.
  if (jobPostsEnabled === true) {
    return NotificationAudience.Provider;
  }
  return NotificationAudience.OrganizationMember;
}
